import React, { useState } from 'react';
import { useDemo } from '@app/providers/DemoContext';
import { useNavigate } from 'react-router-dom';
import './DemoControls.css';

const DemoControls = () => {
  const {
    isDemoMode,
    restartDemo,
    exitDemo,
    isLoadingDemo,
    toggleDemoTour,
    demoTourActive
  } = useDemo();
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  if (!isDemoMode) {
    return null;
  }

  const handleRestartDemo = async () => {
    try {
      await restartDemo();
      setIsMenuOpen(false);
      // Recargar la página para asegurar estado limpio
      window.location.reload();
    } catch (error) {
      console.error('Error al reiniciar demo:', error);
    }
  };

  const handleExitDemo = async () => {
    try {
      await exitDemo();
      setIsMenuOpen(false);
      navigate('/');
    } catch (error) {
      console.error('Error al salir de demo:', error);
    }
  };

  const handleToggleTour = () => {
    toggleDemoTour();
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Botón de controles */}
      <div className="demo-controls">
        <button
          className={`demo-controls__trigger ${isMenuOpen ? 'demo-controls__trigger--active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Controles de demo"
          title="Controles de demo"
        >
          <i className="fas fa-cog"></i>
        </button>

        {/* Menú de controles */}
        <div className={`demo-controls__menu ${isMenuOpen ? 'demo-controls__menu--open' : ''}`}>
          <div className="demo-controls__header">
            <h4>Controles de Demo</h4>
            <button
              className="demo-controls__close"
              onClick={() => setIsMenuOpen(false)}
              aria-label="Cerrar menú"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          <div className="demo-controls__content">
            <div className="demo-controls__info">
              <i className="fas fa-info-circle"></i>
              <span>Está viendo la demostración del sistema supervisor con datos simulados</span>
            </div>

            <div className="demo-controls__actions">
              <button
                className="demo-controls__action demo-controls__action--tour"
                onClick={handleToggleTour}
                disabled={isLoadingDemo}
              >
                <i className={`fas ${demoTourActive ? 'fa-eye-slash' : 'fa-route'}`}></i>
                <span>{demoTourActive ? 'Desactivar Tour' : 'Tour Guiado'}</span>
              </button>

              <button
                className="demo-controls__action demo-controls__action--restart"
                onClick={handleRestartDemo}
                disabled={isLoadingDemo}
              >
                <i className="fas fa-redo"></i>
                <span>Reiniciar Demo</span>
              </button>

              <button
                className="demo-controls__action demo-controls__action--exit"
                onClick={handleExitDemo}
                disabled={isLoadingDemo}
              >
                <i className="fas fa-sign-out-alt"></i>
                <span>Salir de Demo</span>
              </button>
            </div>

            <div className="demo-controls__footer">
              <small>
                <i className="fas fa-database"></i>
                Datos locales simulados
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay para cerrar menú */}
      {isMenuOpen && (
        <div
          className="demo-controls__overlay"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </>
  );
};

export default DemoControls;
